import {
  SET_ACCORDIONS,
  UPDATE_ACCORDIONS,
} from '@data/constants/actionTypes/accordions';

const setAccordions = (value) => ({
  type: SET_ACCORDIONS,
  value,
});

const updateAccordions = (value) => ({
  type: UPDATE_ACCORDIONS,
  value,
});

export {
  setAccordions,
  updateAccordions,
};
